export enum VehicleStatus {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    ACTIVATION_REQUESTED = 'ACTIVATION_REQUESTED',
    ENROLLMENT_DENIED = 'ENROLLMENT_DENIED',
    DENIED_RETRYABLE = 'DENIED_RETRYABLE',
    ENROLLED = 'ENROLLED',
    DEACTIVATION_REQUESTED = 'DEACTIVATION_REQUESTED',
    DEACTIVATED_REENROLLABLE = 'DEACTIVATED_REENROLLABLE',
    DEACTIVATED = 'DEACTIVATED',
}
